'use strict';

angular.module('DoohApps').service('accountBLL', ['$location', '$uibModal', 'Account', 'UploadFileStorage', 'FileUpload', 'DialogHandler', 'DoohConfig', 'SessionHelper', 'User', 'DoohHelper',
        function ($location, $uibModal, Account, UploadFileStorage, FileUpload, DialogHandler, DoohConfig, SessionHelper, User, DoohHelper) {

            this.login = function (callback, dataObject) {
                Account.login(
                    function (data) {
                        login(callback, data)
                    },
                    function (data) {
                        login(callback, data)
                    },
                    dataObject);
            };

            this.logout = function (callback) {
                Account.logout(function () { logout(callback) });
            };

            this.sendRegistrationRequest = function (callback, dataObject) {
                Account.sendRegistrationRequest(function (data) { responseHandler(callback, data) }, dataObject);
            };

            this.register = function (callback, dataObject) {
                Account.register(function (data) { registrationResponse(callback, data) }, dataObject);
            };

            this.getProfile = function (callback) {
                Account.getProfile(function (data) {
                    var jsonData = data.Data.Content;
                    callback(jsonData);
                });
            };

            this.getAccountInfo = function (callback) {
                Account.getAccountInfo(function (data) {
                    var jsonData = data.Data.Content;
                    callback(jsonData);
                });
            };

            this.changePassword = function (callback, dataObject) {
                Account.changePassword(function (data) { responseHandler(callback, data) }, dataObject);
            };

            this.sendInvitaion = function (callback, dataObject) {
                Account.sendInvitation(function (data) { responseHandler(callback, data) }, dataObject);
            };

            this.getUserByInviteCode = function (callback, dataObject) {
                Account.getUserByInviteCode(function (data) { responseHandler(callback, data) }, dataObject);
            };

            this.checkEmail = function (callback, email) {
                Account.checkEmail(function (data) { responseHandler(callback, data) }, email);
            }

            this.getNewPassword = function (callback, email) {
                //Generate url and send it to user via mail.
                Account.getNewPasswordLink(function (data) { responseHandler(callback, data) }, { 'email': email });
            }

            this.resetNewPassword = function (callback, dataObject) {
                Account.resetNewPassword(function (data) { responseHandler(callback, data) }, dataObject);
            }

            this.updateUserDetails = function (callback, dataObject) {
                Account.updateUserDetails(function (data) { responseHandler(callback, data) }, dataObject);
            }

            /* Responses */
            function responseHandler(callback, data) {
            callback({
                hasError: data.hasError || (data.Data != undefined && data.Data.error != undefined) || data.error != undefined || data.error_description != undefined,
                error: getErrorMessage(data),
                message: data.message || (data.Data != undefined ? data.Data.message : null),
                content: (data.Data != undefined) ? ((data.Data.Content != undefined) ? data.Data.Content : {}) : {}
            });
        }

            function getErrorMessage(data) {
                if (data.hasError)
                    return data.errors[0];

                return data.error_description || data.error || (data.Data != undefined ? data.Data.error : null);
            }

            function login(callback, data) {
                var res = {
                    hasError: (data.Data != undefined && data.Data.error != undefined) || data.error != undefined || data.error_description != undefined,
                    error: data.error_description || data.error || (data.Data != undefined ? data.Data.error : null),
                    message: data.message || (data.Data != undefined ? data.Data.message : null),
                    content: (data.Data != undefined) ? ((data.Data.Content != undefined) ? data.Data.Content : {}) : {}
                };

                if (!res.hasError) {
                    SessionHelper.setAccessToken(data.Data.access_token, data.Data['.expires']);
                    SessionHelper.setRefreshToken(data.Data.refresh_token);
                    SessionHelper.setUserCredentials(data.Data);
                    var user = JSON.parse(DoohHelper.getProperty(data.Data, 'user'));
                    User.setUser(user);
                    res.content = data.Data;
                } else {
                    SessionHelper.clearSessionLocalStorage();
                    User.clear();
                }
                callback(res);
            }

            function logout(callback) {
                SessionHelper.clearSessionLocalStorage();
                callback();
            }

            function registrationResponse(callback, data) {

                var res = {
                    hasError: (data.Data != undefined && data.Data.error != undefined) || data.error != undefined || data.error_description != undefined,
                    error: data.error_description || data.error || (data.Data != undefined ? data.Data.error : null),
                    message: data.message || (data.Data != undefined ? data.Data.message : null),
                    content: (data.Data != undefined) ? ((data.Data.Content != undefined) ? data.Data.Content : {}) : {}
                }
                if (!res.hasError) {
                    logout(function () {
                        User.clear();
                        Account.login(function (data) { login(callback, data) }, function (data) { login(callback, data) },
                            {
                                grant_type: 'password',
                                username: data.Config.data.Email,
                                password: data.Config.data.Password,
                            });
                    });
                } else {
                    callback(res);
                }
            }

        this.SaveProfileImage = function (onProgress, onSuccess, onError) {
                var files = UploadFileStorage.GetFiles();
            var uploadUrlReceivedHandler = createFileUploadUrlReceivedHandler(files[0], onProgress, onSuccess, onError);
                if (files[0].type.indexOf('text') == -1) {
                FileUpload.getFileUploadUrl(uploadUrlReceivedHandler, files[0].name);
                }
            }

        function createFileUploadUrlReceivedHandler(file, onProgress, onSuccess, onError) {
            return function (url, token) {
                FileUpload.upload({
                    file,
                    url,
                    token,
                    onProgress,
                    onSuccess,
                    onError
                });
            }
        }

            this.updateProfileImage = function (callback, url) {
            Account.updateProfileImage(function (data) {
                    responseHandler(callback, data);
            }, { imageURL: url });
            }

            this.deleteProfileImage = function (callback) {
                Account.deleteProfileImage(function (data) { callback(data); });
            }

            this.setTimeZone = function (callback, timezone) {
                Account.setTimeZone(function (data) { callback(data) }, timezone);
            }

            this.resendActivation = function (callback, personID) {
            Account.resendActivation(function (data) {
                responseHandler(callback, data)
            }, personID);
        }

        this.getNewPasswordLinkAdmin = function (callback, personID) {
            Account.getNewPasswordLinkAdmin(function (data) {
                responseHandler(callback, data)
            }, personID);
            }

            this.isAuthenticated = function (callback) {
                Account.isAuthenticated(function (data) { callback(data) });
            }

            this.resendActivationemail = function (callback, email) {
                Account.resendActivationemail(function (data) { callback(data) }, email);
            }

            this.setLastUsedVersion = function (callback, personID, version) {
                Account.setLastUsedVersion(function (data) { callback(data) }, personID, version);
            }

            this.changeLanguage = function (callback, language) {
                Account.changeLanguage(function (data) { callback(data) }, language);
        }
        }]);